import { render, staticRenderFns } from "./PropertyBasedForm.vue?vue&type=template&id=1d1d83a1&scoped=true"
import script from "./PropertyBasedForm.vue?vue&type=script&lang=js"
export * from "./PropertyBasedForm.vue?vue&type=script&lang=js"
import style0 from "./PropertyBasedForm.vue?vue&type=style&index=0&id=1d1d83a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1d83a1",
  null
  
)

export default component.exports